// material
import {Box, Container, Grid, Paper, Skeleton, Typography} from "@mui/material";
import { styled } from "@mui/material/styles";
// mantenedorAdmin
import RedirectButton from "../RedirectButton";
import useGetServices from "../../../hooks/portal/useGetServices";

const ImgStyled = styled(Box)(({ theme }) => ({
  width: "100%",
  height: { xs: 170, md: 200 },
  // objectFit: "cover",
  borderRadius: 8,
}));

export default function Services() {
  const {loading, services} = useGetServices()
  return (
    <Container  sx={{ py: { xs: 5, md: 10 } }}>
      <Typography variant="h2" align="center" sx={{ mb: 2 }}>
        Servicios
      </Typography>
      {
        loading &&
        <Grid container spacing={5} sx={{my: 5, px: 5}}>
          {
            [...Array(3)].map((el, index) => (
              <Grid key={index} item xs={12} md={4}>
                <Skeleton variant={"rectangular"} width='200' height={200}/>
                <Typography variant='h5'><Skeleton/></Typography>
                <Typography variant='h6'><Skeleton/></Typography>
              </Grid>
            ))
          }
        </Grid>
      }
      <Grid container spacing={2}>
        {
          services && services.length > 1 && !loading && services.map((service) => (
            <Grid item xs={6} md={4} key={service._id}>
              <Paper elevation={4} sx={{ mb: 2 }}>
                {/*tomamos el valor Banner_Mobile para esta seccion para mantener uniformidad*/}
                <ImgStyled
                  component="img"
                  loading='lazy'
                  alt={service.ALT}
                  src={service.Banner_Mobile}
                />
              </Paper>
              <Typography variant="subtitle2">{service.Titulo}</Typography>
              <RedirectButton url='/servicios'/>
            </Grid>
          ))
        }
      </Grid>
    </Container>
  );
}
